import { recordListingEvent } from '../../../../Redux/Actions/recordListingEvent';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import $, { map } from 'jquery';
import { DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import 'bootstrap/dist/css/bootstrap.css';
import MapModalForView from '../../../common/Modal/MapModalForView';
import ServicesScroller from '../../../common/ServiceScroll/ServiceScroller';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/service-provider/quick-servicing/banner-a.jpg',
  },
];

export default function QuickServicesDetails() {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  var home = useSelector((state) => state.home);
  const quickServiceDetails = home?.getDetailList?.[0];
  const dispatch = useDispatch();
  const [mapModalOpen, setMapModalOpen] = useState(false);

  const { quickServiceOwnerId } = useParams();
  useEffect(() => { if (quickServiceOwnerId) recordListingEvent(quickServiceOwnerId, 'quickService', 'VIEW'); }, [quickServiceOwnerId]);

  useEffect(() => {
    const fetchDetail = async (data) => {
      var object = { quickServiceOwnerId };
      console.log('this is fatch ondata ', object);
      let query = '';
      Object.keys(object).forEach((key) => {
        console.log('this is object key', key);
        query += key + '=' + object[key] + '&';
      });
      query = query.slice(0, -1);
      console.log('this is the,', query);
      try {
        // console.log('fetch data part', data);
        axios

          .get(
            `https://api.carsavenue.com/api/quickServiceOwner/listing` +
              '?' +
              query,

            config
          )

          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: DETAIL_LIST,
              payload: res.data.response,
            });

            // setgarageDataDetail(res);

            console.log('heeee<<<<', res);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        // Swal.fire('Incorrect Credentials', '', 'error');
      }
    };
    if (quickServiceOwnerId && quickServiceOwnerId !== '')
      fetchDetail({ quickServiceOwnerId });
  }, [dispatch, quickServiceOwnerId]);

  console.log('getDetailList', quickServiceDetails);

  if (!quickServiceDetails) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  //business images
  const logo = quickServiceDetails?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  )?.media?.path;

  let bannerImages = defaultImages;

  if (
    quickServiceDetails?.businessMedia &&
    quickServiceDetails.businessMedia.length > 0
  ) {
    const mediaImages = quickServiceDetails.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Location Data
  const gpsData =
    typeof quickServiceDetails?.gps === 'string'
      ? JSON.parse(quickServiceDetails?.gps)
      : quickServiceDetails?.gps || '{}';
  const lat = parseFloat((gpsData || {}).lat);
  const lng = parseFloat((gpsData || {}).long);

  //Business Calendar
  const businessCalendar =
    typeof quickServiceDetails?.calendar === 'string'
      ? JSON.parse(quickServiceDetails?.calendar)
      : quickServiceDetails?.calendar;

  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = (businessCalendar || {})[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  //Social Media Data
  const socialMediaData =
    typeof quickServiceDetails?.socialMedia === 'string'
      ? JSON.parse(quickServiceDetails?.socialMedia)
      : quickServiceDetails?.socialMedia;

  //services
  const services = quickServiceDetails?.quickServices?.map((item) => ({
    service: item?.quickService?.quickService,
    media: item?.quickService?.media,
    // [FB2-#1] Keep the supported vehicle types (car brands) per service.
    brands: item?.carBrands || [],
  }));
  return (
    <div>
      <div class="user-banner">
        <CommonBanner bannerImages={bannerImages} />

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-4 col-md-3">
                      <img
                        src={logo || 'assets/images/user/taxi/user.jpg'}
                        alt=""
                        class="img-fluid user-garage-logo"
                        style={{
                          objectFit: 'contain',
                          backgroundColor: '#fff',
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'assets/images/user/taxi/user.jpg';
                        }}
                      />
                    </div>
                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">
                        {quickServiceDetails?.quickServiceOwnerName}
                      </h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            target="_blank"
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            onClick={() => recordListingEvent(quickServiceOwnerId, 'quickService', 'CONTACT')} href={`https://wa.me/${`${quickServiceDetails?.whatsAppNumberCountryCode}${quickServiceDetails?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <CallLink
                            target="_blank"
                            onClick={() => recordListingEvent(quickServiceOwnerId, 'quickService', 'CONTACT')} record={quickServiceDetails}
                          >
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                    <span class={isOpen ? 'open-time' : 'close-time'}>
                      {isOpen ? t('Open Now') : t('Close Now')}
                    </span>{' '}
                    |{' '}
                    <span class={isOpen ? 'close-time' : 'open-time'}>
                      {isOpen
                        ? `${t('Closes at')} ${nextActionTime}`
                        : `${t('Open at')} ${nextActionTime}`}
                    </span>
                  </p>
                  )}
                  <ul className="list-inline mb-0">
                    {quickServiceDetails?.website && (
                      <li className="list-inline-item">
                        <a
                          href={externalUrl(quickServiceDetails?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            className="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => (
                            <tr>
                              <td scope="col">{t(day)}</td>
                              <td scope="col">
                                {businessCalendar?.[day]?.openTime}
                              </td>
                              <td scope="col">
                                {businessCalendar?.[day]?.endTime}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content-area">
        <div class="container">
          <h5 className="cav-section-title">{t('About Us')}</h5>
          {quickServiceDetails?.about?.split('\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}
          <p>{quickServiceDetails?.category}</p>
          <p>{quickServiceDetails?.location}</p>
          {/* [CF-5] Website moved to an icon beside the social icons. */}

          <h5 className="cav-section-title">{t('Services Provided')}</h5>
          {/* [CF 2026-08-01 v2] Service name + its supported brands as chips.
              Only the "Supported Vehicle Types" LABEL was meant to go; a
              briefly shipped version also dropped the chips, which the client
              corrected. Same `cav-part-card` / `cav-brand-chip` classes as the
              spare-parts shop card. */}
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '12px',
              marginTop: '4px',
            }}
          >
            {(services || []).map((s, si) => {
              const brandNames = (s?.brands || [])
                .map((b) => {
                  const brand = b?.brand || b;
                  return isRTL
                    ? brand?.nameAr || brand?.name
                    : brand?.name || brand?.nameAr;
                })
                .filter(Boolean);
              return (
                <div
                  key={si}
                  className="cav-part-card"
                  style={{
                    flex: '1 1 240px',
                    minWidth: '200px',
                    maxWidth: '360px',
                    textAlign: isRTL ? 'right' : 'left',
                  }}
                >
                  <div
                    className="cav-part-name"
                    style={
                      brandNames.length
                        ? undefined
                        : {
                            borderBottom: 'none',
                            marginBottom: 0,
                            paddingBottom: 0,
                          }
                    }
                  >
                    {s?.service}
                  </div>
                  {brandNames.length > 0 && (
                    <div className="cav-part-brands">
                      {brandNames.map((bn, bi) => (
                        <span key={bi} className="cav-brand-chip">
                          {bn}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* <div class="row">
            {quickServiceDetails?.quickServices?.map((dt) => (
              <div class="col-4 col-sm-4 col-md-3 col-lg-2 mb-4">
                <div class="quick-service-block">
                  <div class="line-a">
                    <img
                      style={{
                        width: '3rem',
                        height: '3rem',
                        borderRadius: '50%',
                      }}
                      src={dt?.quickService?.media?.path}
                      alt="quick-service-logo"
                    />
                  </div>
                  <div class="line-b">{t(dt?.quickService?.quickService || '')}</div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </div>
  );
}
